// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__yViqM","layout__auth":"layout_layout__auth__uP6OV"};